import React from 'react';
import parse from 'html-react-parser';
import makeBodyText from '../../../utils/makeText';
import styles from '../index.module.scss';
const MAX_ELEM_IN_COLUMN = 6;
const MAX_ELEM_IN_COLUMN_NC = 3;
const Links = ({ links, ncMarketing }) => {
    const maxCount = ncMarketing ? MAX_ELEM_IN_COLUMN_NC : MAX_ELEM_IN_COLUMN;
    const columns = Math.ceil(links.length / maxCount);
    const columnsArray = Array.from(Array(columns).keys());
    const renderText = (text) => {
        if (ncMarketing) {
            return parse(text);
        }
        return text;
    };
    const linksToRender = links.map((link) => {
        return (React.createElement("a", { key: link.label, className: `${makeBodyText('L')} ${styles.link}`, href: link.href, target: link.target }, renderText(link.label)));
    });
    const linksSlicer = (min, max) => (link, index) => {
        if (index >= min && index < max) {
            return link;
        }
        return null;
    };
    // slicing links by their columns
    return columnsArray.map((columnID) => {
        const minIndexToInject = columnID * maxCount;
        const maxIndexToInject = (columnID + 1) * maxCount;
        const linksToInject = linksToRender.map(linksSlicer(minIndexToInject, maxIndexToInject));
        return (React.createElement("div", { key: columnID, className: `${styles.column} ${ncMarketing ? 'col' : ''}` }, linksToInject));
    });
};
export default Links;
